const BrixLogoColor = Object.freeze({
    lifeAquatic: "lifeAquatic",
    hotPink: "hotPink",
    purpleHaze: "purpleHaze",
    bloodOrange: "bloodOrange",
    mellowYellow: "mellowYellow",
    grey: "grey",
    electricBlue: "electricBlue",
    white : "white",
    black: "black"
});

export default BrixLogoColor;
